import { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress, Avatar } from '@mui/material';
import { GoogleMap, OverlayView } from '@react-google-maps/api';
import { getLatLong, isEmpty, urlImg } from '../../common/helpers';

const containerStyle = {
  width: '100%',
  height: '350px',
  borderRadius: '12px'
};

const ServiceLocation = ({ service, profile, user }) => {
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCoords = async () => {
      if (service?.ubicacion?.direccion) {
        setLoading(true);
        try {
          const res = await getLatLong(service.ubicacion.direccion);
          if (res) {
            setCoords(res);
          }
        } catch (error) {
          console.error("Error fetching coordinates:", error);
        }
        setLoading(false);
      }
    };

    if (service?.modalidades?.includes('Presencial')) {
      fetchCoords();
    }
  }, [service]);

  if (!service?.modalidades?.includes('Presencial') || !service?.ubicacion?.direccion) {
    return null;
  }

  const avatarUrl = !isEmpty(user?.avatar)
    ? `${urlImg}/w_100,h_100,c_fill/users/${user?._id}/${user?.avatar}`
    : '/logo3.png';

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold" color="#0E2465">
          Ubicación
        </Typography>
        <Typography variant="body2" color="#737791">
          Conoce donde está ubicado este negocio
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid #F0F0F0',
          height: '350px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: '#f5f5f5'
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : coords ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={coords}
            zoom={15}
            options={{
              disableDefaultUI: false,
              zoomControl: true,
              styles: [
                {
                  featureType: "poi",
                  elementType: "labels",
                  stylers: [{ visibility: "off" }]
                }
              ]
            }}
          >
            <OverlayView
              position={coords}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  position: 'absolute',
                  transform: 'translate(-50%, -100%)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  zIndex: 1000
                }}
              >
                {/* Custom Pin Container */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  padding: '4px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                  width: '56px',
                  height: '56px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  border: '1px solid #eee'
                }}>
                  <Avatar
                    src={avatarUrl}
                    sx={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid #F0F0F0'
                    }}
                  />
                  {/* Pin Pointer/Triangulo */}
                  <div style={{
                    position: 'absolute',
                    bottom: '-12px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '0',
                    height: '0',
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                    borderTop: '12px solid white',
                  }} />
                </div>
              </div>
            </OverlayView>
          </GoogleMap>
        ) : (
          <Typography color="textSecondary">No se pudo cargar el mapa</Typography>
        )}
      </Paper>
      <Typography variant="body2" color="#737791" sx={{ mt: 1 }}>
        {service.ubicacion.direccion}
      </Typography>
    </Box>
  );
};

export default ServiceLocation;
